import { get, post } from "../AxiosConfig";

const URI = "/company";

const listCompany = (payload) => {
  const URL = `${URI}/list-company`;
  return post(URL, payload);
};

const createCompany = (payload) => {
  const URL = `${URI}/create-company`;
  return post(URL, payload);
};

const updateCompany = (payload) => {
  const URL = `${URI}/update-company`;
  return post(URL, payload);
};

const deleteCompany = (payload) => {
  const URL = `${URI}/delete-company`;
  return post(URL, payload);
};

// ─── Module activation (תשתית — הרה-פקטור המודולרי הגדול עתידי) ──────────────
export const MODULE_CODES = {
  PROFITABILITY:    'Profitability',
  INVOICES:         'Invoices',
  EXPENSES:         'Expenses',
  COST_CALCULATION: 'CostCalculation',
};

const getCompanyModules = ({ companyId, activeOnly = false }) =>
  get(`/company/modules?companyId=${companyId}&activeOnly=${activeOnly ? 1 : 0}`);

const toggleCompanyModule = (payload) =>
  post(`/company/module-toggle`, payload);

const CompanyService = {
  listCompany,
  createCompany,
  updateCompany,
  deleteCompany,
  getCompanyModules,
  toggleCompanyModule,
};

export default CompanyService;
